module.exports = __webpack_public_path__ + "static/media/review1.278fdfb0.webm";